import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Col } from 'antd';

import CustomMaskedInput from 'components/MaskedInput';
import { usePhysicalDeliveryStore } from 'v2/store/PhysicalDelivery';
import { run } from 'validations/ruleRunner';

import Validations from './validations';

interface IProps {
  enabledValidation: boolean;
  onEdit?: () => void;
}

const Free: React.FC<IProps> = ({ enabledValidation, onEdit }) => {
  const { delivery, setDelivery } = usePhysicalDeliveryStore();
  const [validationErrors, setValidationErrors] = useState<any>([]);
  const prevDeliveryRef = useRef(delivery);
  const prevEnabledValidationRef = useRef(enabledValidation);

  const errorFor = (field: any) => validationErrors[field] || '';
  const isValid = (field: any) => !!validationErrors[field];
  const executeValidation = useCallback(() => {
    setValidationErrors(run(delivery, Validations));
  }, [delivery]);
  const handleChange = useCallback(
    (prop: string, value: any) => {
      if (onEdit) onEdit();
      setDelivery({ ...delivery, [prop]: value });
    },
    [delivery, onEdit, setDelivery]
  );

  useEffect(() => {
    if (enabledValidation) executeValidation(); /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  useEffect(() => {
    if (
      (!prevEnabledValidationRef.current && enabledValidation) ||
      (enabledValidation && prevDeliveryRef.current !== delivery)
    )
      executeValidation();
    prevDeliveryRef.current = delivery;
    prevEnabledValidationRef.current = enabledValidation;
  }, [delivery, enabledValidation, executeValidation]);

  return (
    <Col sm={24}>
      <CustomMaskedInput
        label='Prazo de entrega'
        fullWidth={true}
        disableUnderline
        id='delivery_days'
        mask='number'
        helperText={isValid('delivery_days') ? errorFor('delivery_days') : 'Dias corridos'}
        error={isValid('delivery_days')}
        value={delivery.delivery_days}
        onChange={(value: any) => handleChange('delivery_days', value)}
        InputLabelProps={{ shrink: true }}
        endAdornment='Dias'
      />
    </Col>
  );
};

export default Free;
